import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as siteActions from 'actions/siteActions';
import ThemeSelector from 'layoutComponents/ThemeSelector';
import Footer from 'containers/Footer';

export class SettingPage extends React.Component {

    constructor(props, context) {
        super(props, context);

    }

    render() {
        const {siteActions} = this.props;

        return (
            <div>
                <div className="row">
                    <div className="col s12">
                        <label>Theme</label>
                    </div>
                </div>
                <div className="row">
                    <div className="col s12">
                        <ThemeSelector siteActions={siteActions}/></div>
                </div>
                <Footer/>
            </div>

        );
    }
}
SettingPage.propTypes = {
    siteActions: PropTypes.object
};
function mapDispatchToProps(dispatch) {
    return {
        siteActions: bindActionCreators(siteActions, dispatch)
    };
}

function mapStateToProps(state) {
    return {
        site: state.get('site')
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingPage);



// WEBPACK FOOTER //
// ./src/containers/pages/SettingPage.js